import { render, staticRenderFns } from "./DNSBindingForm.vue?vue&type=template&id=3edb1f34&"
import script from "./DNSBindingForm.vue?vue&type=script&lang=js&"
export * from "./DNSBindingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports